import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { PortfolioImportFlow } from '~/components/portfolio/import/portfolio-import-flow.tsx';
import { getPortfolioImportPageDataQueryOptions } from '~/server/portfolio/portfolio-import-page-data-query.ts';

interface PortfolioImportSearch {
	readonly portfolioCurrency?: string;
	readonly portfolioName?: string;
	readonly returnUrl?: string;
}

function validatePortfolioImportSearch(search: Record<string, unknown>): PortfolioImportSearch {
	return {
		portfolioCurrency: typeof search.portfolioCurrency === 'string' ? search.portfolioCurrency : undefined,
		portfolioName: typeof search.portfolioName === 'string' ? search.portfolioName : undefined,
		returnUrl: typeof search.returnUrl === 'string' ? search.returnUrl : undefined,
	};
}

export const Route = createFileRoute('/portfolios/$portfolioId_/import')({
	component: PortfolioImportPage,
	head: () => ({
		meta: [{ title: 'Import Transactions' }],
	}),
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			getPortfolioImportPageDataQueryOptions({ portfolioId: Number(params.portfolioId) }),
		),
	validateSearch: validatePortfolioImportSearch,
});

function PortfolioImportPage() {
	const { portfolioId } = Route.useParams();
	const { data: loaderData } = useSuspenseQuery(
		getPortfolioImportPageDataQueryOptions({ portfolioId: Number(portfolioId) }),
	);
	const search = Route.useSearch();

	return <PortfolioImportFlow context={loaderData.context} returnUrl={search.returnUrl} />;
}
